import courseListSubjects from './course_list_subjects';

function mapValuedFilter(mapped, clientFilter) {
  if (!mapped[clientFilter.filter]) {
    mapped[clientFilter.filter] = [];
  }
  mapped[clientFilter.filter].push(
    clientFilter.value,
    ...(courseListSubjects[clientFilter.value] || [])
  );
}

function mapRangedFilter(mapped, any, clientFilter) {
  if (clientFilter.type === 'checkbox') {
    any.push({ [clientFilter.filter]: clientFilter.range });
  } else {
    mapped[clientFilter.filter] = clientFilter.range;
  }
}

export default function(clientFilters) {
  const mapped = {}, any = [];

  // parses the array of filters into a format for use by elasticsearch
  // https://swiftype.com/documentation/app-search/api/search/filters
  clientFilters.forEach(cf => {
    if (cf.value) {
      mapValuedFilter(mapped, cf);
    } else if (cf.range) {
      mapRangedFilter(mapped, any, cf);
    }
  });

  return { mapped, any };
}
